<template>
  <!-- Body -->
  <div class="d-flex flex-column align-center">
    <!-- Only show entrance if portal is active -->
    <v-img v-if="hasPortalUrl" @click="enter" @mouseover="isOpen = true" @mouseleave="isOpen = false" id="entrance"
      class="portal-effect" :src="isOpen ? srcOpen : srcClose" lazy></v-img>
    <!-- Show different building based on portal active status -->
    <div id="building" :class="{ 'active-building': hasPortalUrl, 'default-building': !hasPortalUrl }"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),

    // Get the URL for the current language or null if not available
    portalUrl() {
      const currentLang = this.$_getLocale();
      return this.portalUrls[currentLang] || null;
    },

    // Check if portal should be active (has URL for current language and within date range)
    hasPortalUrl() {
      // First check if there's a URL for the current language
      if (!this.portalUrl) return false;
      
      // Then check if current date is within the configured date range using moment
      const now = this.$moment();
      const startDate = this.$moment(this.portalDateStart);
      const endDate = this.$moment(this.portalDateEnd);
      
      return now.isSameOrAfter(startDate) && now.isSameOrBefore(endDate);
    }
  },
  props: [
    //
  ],
  data: () => ({
    isOpen: false,
    srcClose: require('@/assets/world/buildings/WordBuildingPortalEntrance.png'),
    srcOpen: require('@/assets/world/buildings/WordBuildingPortalEntrance.png'),
    // Parse the portal URLs from the JSON string in the environment variable
    portalUrls: process.env.VUE_APP_PORTAL_URLS ? JSON.parse(process.env.VUE_APP_PORTAL_URLS) : { en: null, ms: null, zh: null },
    // Get portal date range from environment variables
    portalDateStart: process.env.VUE_APP_PORTAL_DATE_START,
    portalDateEnd: process.env.VUE_APP_PORTAL_DATE_END,
  }),
  created() {
    // Log portal configuration for debugging
    console.log('Portal configuration:', {
      urls: this.portalUrls,
      currentUrl: this.portalUrl,
      dateStart: this.portalDateStart,
      dateEnd: this.portalDateEnd,
      currentLang: this.$_getLocale(),
      now: this.$moment().format(),
      isAfterStart: this.$moment().isSameOrAfter(this.$moment(this.portalDateStart)),
      isBeforeEnd: this.$moment().isSameOrBefore(this.$moment(this.portalDateEnd)),
      portalActive: this.hasPortalUrl,
      buildingType: this.hasPortalUrl ? 'active' : 'default',
      showEntrance: this.hasPortalUrl
    });
  },
  mounted() {
    //
  },
  methods: {
    enter() {
      // Only do something if portal is active
      if (this.hasPortalUrl) {
        this.isOpen = true;
        // Open URL in a new window
        if (this.portalUrl) {
          window.open(this.portalUrl, '_blank');
        }
      }
    },
  },
};
</script>

<style scoped>
#building {
  position: absolute;
  width: 100vw;
  height: 100vh;
  bottom: 170px;
  background-size: auto;
  background-position: center bottom;
  z-index: 2;
  pointer-events: none;
}

.active-building {
  background-image: url("../../../assets/world/buildings/WorldBuildingPortal_960x512.png");
}

.default-building {
  background-image: url("../../../assets/world/buildings/WorldBuildingPortalDefault_960x512.png");
}

#entrance {
  cursor: pointer;
  position: absolute;
  width: 205px;
  height: 192px;
  bottom: 250px;
  left: -20px;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  filter:
    drop-shadow(3px 0 0 rgba(255, 255, 255, 0.3)) drop-shadow(-3px 0 0 rgba(255, 255, 255, 0.3)) drop-shadow(0 3px 0 rgba(255, 255, 255, 0.3)) drop-shadow(0 -3px 0 rgba(255, 255, 255, 0.3));
  z-index: 1;
}

/* Portal effect only applied when a URL is available */
.portal-effect {
  animation: rotate-portal 5s linear infinite;
}

.portal-effect:hover {
  filter:
    drop-shadow(0 0 4px rgba(255, 255, 0, 0.8)) drop-shadow(0 0 8px rgba(255, 255, 0, 0.6)) drop-shadow(0 0 12px rgba(255, 255, 0, 0.4)) !important;
  /* animation: rotate-portal 8s linear infinite; */
}

@keyframes rotate-portal {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>